<script setup>
    import { close_button_ui_styles, modal_ui_styles } from '@/utilities/ui';    

    const { $bus } = useNuxtApp();

    const open = defineModel('open');

    const props = defineProps({
        session: {
            type: Object,
            default: () => ({}),
            required: true
        }
    });

    watch(() => props.session, (newSession) => {
        if (newSession && newSession.id) {
            console.info('Favorited session updated:', newSession.title);
        }
    });

    const handleConfirm = async () => {
        if (!props.session?.id) return;
        open.value = false;
        setTimeout(async () => {
            await navigateTo(`/reservations/${props.session.id}`);
        }, 250);
    };

    watch(open, (val) => {
        if (val) {
            $bus.emit('drawer-open');
        } else {
            $bus.emit('drawer-close');
        }
    });
</script>

<template>
    <UModal
        v-model:open="open"
        title="Save a Seat for a Favorited Session"
        :ui="modal_ui_styles"
        :dismissable="false"
        :close="close_button_ui_styles"
        class="reservations-modal leave-modal">
        <template #body>
            <div class="flex flex-col items-center justify-center inner">
                <h1 class="h1">"{{ session.title }}" has been added to My Favorites!</h1>
                <div class="warning-banner">
                    <UIcon name="local-warning" class="warning-icon" />
                    <p>This session has a limited number of seats available and requires a seat reservation to attend.</p>
                </div>
                <div class="actions">
                    <UButton label="Yes, Save a Seat" variant="outline-close" @click="handleConfirm" />
                    <UButton label="Don't Save a Seat" variant="outline-close" color="orange" @click="open = false" />                    
                </div>
            </div>
        </template>
    </UModal>
</template>

<style lang="scss" scoped>
    .reservations-modal {
        color: var(--teal-13);

        .inner {
            max-width: 41.875rem;
            width: 100%;
            padding-bottom: 2.5rem;

            &.spinner {
                gap: 1.6875rem;

                .warning-banner {
                    margin-bottom: 0;
                }

                .h1 {
                    margin-bottom: 0;
                }

                .spin-text {
                    color: var(--teal);
                    font-size: 1.0625rem;
                    font-style: normal;
                    font-weight: 300;
                    line-height: 1.75rem;
                    letter-spacing: 0.02125rem;
                }
            }

            .actions {
                display: flex;
                flex-direction: row;
                gap: 1.5625rem;
            }

            h1 {
                text-align: center;
                font-size: 2rem;
                font-style: normal;
                font-weight: 500;
                line-height: 2.5rem;
                letter-spacing: -0.04rem;
                margin-bottom: 2rem;
                text-wrap: balance;
            }

            .warning-icon {
                width: 1.5rem;
                height: 1.5rem;
                flex-shrink: 0;
            }

            .warning-banner,
            .success {
                background-color: var(--orange-ghost);
                border-radius: var(--radius);
                padding: 1.8125rem;
                color: var(--orange-ghost-dark);
                font-size: 0.875rem;
                font-style: normal;
                font-weight: 400;
                line-height: 1.25rem;
                display: flex;
                flex-direction: column;
                gap: 1rem;
                margin-bottom: 2.8125rem;
                letter-spacing: 0;
                width: 100%;

                @media (min-width: $tablet) {
                    flex-direction: row;
                    align-items: center;
                    gap: 1.644375rem;
                }
            }
        }
    }
</style>
